import { Injectable } from '@angular/core';
import { CatalogNode } from '@catalog/const/v2';
import { select, Store } from '@ngrx/store';
import { combineLatest, Observable, switchMap, take, tap } from 'rxjs';
import { CatalogActions } from '../store/actions';
import { StateWithCatalog } from '../store/catalog-state';
import { CatalogSelectors } from '../store/selectors';

@Injectable({ providedIn: 'root' })
export class CatalogRootNodeIdFacade {
  constructor(private store: Store<StateWithCatalog>) {}

  loadRootNodeId(): void {
    combineLatest({
      rootNodeId: this.store.select(CatalogSelectors.getCatalogRootNodeIdValue),
      isLoading: this.store.select(CatalogSelectors.getCatalogRootNodeIdLoading),
    })
      .pipe(
        take(1),
        tap(({ rootNodeId, isLoading }) => {
          if (!rootNodeId && !isLoading) {
            this.store.dispatch(new CatalogActions.CatalogRootNodeIdLoad());
          }
        }),
      )
      .subscribe();
  }

  getRootNode(): Observable<CatalogNode | undefined> {
    return this.getRootNodeId().pipe(
      switchMap((rootNodeId) => {
        return this.store.pipe(select(CatalogSelectors.getCatalogNode(rootNodeId)));
      }),
    );
  }

  getRootNodeId(): Observable<string> {
    return this.store.select(CatalogSelectors.getCatalogRootNodeIdValue);
  }

  getRootNodeIdLoading(): Observable<boolean> {
    return this.store.select(CatalogSelectors.getCatalogRootNodeIdLoading);
  }

  getRootNodeIdError(): Observable<boolean> {
    return this.store.select(CatalogSelectors.getCatalogRootNodeIdError);
  }

  getRootNodeIdSuccess(): Observable<boolean> {
    return this.store.select(CatalogSelectors.getCatalogRootNodeIdSuccess);
  }
}
